import * as React from "react";
import { connect } from "react-redux";
import { Redirect, useLocation } from "react-router-dom";
import {
  getSSOCredentials,
  GetSSOCredentialsActionType
} from "src/login/actions";
import LoadingSpinner from "src/shared/LoadingSpinner";
import { getSSORedirectUrl } from "../login/selector";
import { isUserAuthenticated } from "../route/selector";
import selectorsToProps from "../utils/selectorsToProps";
import { exchangeCode, ExchangeCodeActionType } from "./actions";
import { getUserRole } from "./selector";

interface RedirectComponentProps {
  exchangeCode: ExchangeCodeActionType;
  isUserAuthenticated: boolean;
  role: string;
  ssoRedirectUrl: string;
  getSSOCredentials: GetSSOCredentialsActionType;
}

function RedirectComponent(props: RedirectComponentProps) {
  const location = useLocation();
  const code = new URLSearchParams(location.search).get("code");

  React.useEffect(() => {
    const fetchAndRedirect = async () => {
      try {
        const SSOToken = await props.getSSOCredentials();

        if (code) {
          props.exchangeCode({
            code,
            grantType: "authorization_code",
            redirectUri: props.ssoRedirectUrl,
            scope: "openid",
            ssoCredentials: SSOToken
          });
        }
      } catch (error) {
        // tslint:disable-next-line: no-console
        console.error("Error during SSO credential exchange:", error);
      }
    };

    fetchAndRedirect();
  }, []);

  if (props.isUserAuthenticated) {
    return <Redirect to="/spreads" />;
  }

  return (
    <div>
      <LoadingSpinner />
    </div>
  );
}

export default connect(
  selectorsToProps({
    isUserAuthenticated,
    role: getUserRole,
    ssoRedirectUrl: getSSORedirectUrl
  }),
  {
    getSSOCredentials: getSSOCredentials.action,
    exchangeCode: exchangeCode.action
  }
)(RedirectComponent);



// WEBPACK FOOTER //
// ./src/redirectComponent/RedirectComponent.tsx